import { Suspense } from 'react';
import { Outlet } from 'react-router';
import { PageSpinner } from '../spinner';

/** Layout das páginas públicas (login, recuperação de senha, ativação). */
export function PublicLayout() {
  return (
    <div className="public">
      <main className="public__card" id="conteudo">
        <div className="public__brand">
          <img src="/favicon.svg" alt="" width="40" height="40" />
          <span>i9Portal</span>
        </div>
        <Suspense fallback={<PageSpinner />}>
          <Outlet />
        </Suspense>
      </main>
      <p className="public__footer">i9vate · Banco de horas extras e reembolsos</p>
    </div>
  );
}
